import { ReactNode, useCallback, useMemo, useState } from 'react';

import { ModalContext } from './modal-context';

const { Provider } = ModalContext;
interface ProviderProps {
  children: ReactNode;
}

const ModalProvider = ({ children }: ProviderProps): JSX.Element => {
  const [open, setOpen] = useState<string[]>([]);
  const [callbackData, setCallbackData] = useState<Record<string, unknown>>({});

  const openModal = useCallback((name: string, callbackData?: unknown) => {
    if (callbackData !== undefined) {
      setCallbackData((data) => ({ ...data, [name]: callbackData }));
    }
    setOpen((open) => [...open, name]);
  }, []);

  const closeModal = useCallback(
    (name: string) => {
      const filtered = open.filter((x) => x !== name);
      setOpen(filtered);
    },
    [open]
  );

  const isOpen = useCallback(
    (name: string) => {
      return !!open.find((x) => x === name);
    },
    [open]
  );

  const getCallbackData = useCallback(
    (name: string) => {
      return callbackData[name];
    },
    [callbackData]
  );

  const contextValue = useMemo(
    () => ({
      isOpen,
      openModal,
      closeModal,
      getCallbackData,
    }),
    [isOpen, openModal, closeModal, getCallbackData]
  );

  return <Provider value={contextValue}>{children}</Provider>;
};

export default ModalProvider;
